
<br>
<p style="color: #303030;font-size: 43px; margin-left: 20px;">Welcome {{username}}</p>
<p style="margin-left: 20px;">This portal allows you to create bills</p>

<!--<div class="card-columns d-flex justify-content-center">

  <div class="card align-items-center">
      <div class="card-body" (click)="addnewbill()"> <a class="leftabita">Add new Bill</a></div>
  </div>
  <div class="card align-items-center">
    <div class="card-body" (click)="viewbill()"> <a class="leftabita">View Bill</a></div>
  </div>
  <div class="card align-items-center" (click)="deletebill()">
    <div class="card-body"> <a class="leftabita">Delete Bill</a></div>
  </div>
  <div class="card align-items-center">
      <div class="card-body" (click)="fullbill()"> <a class="leftabita">Logged In</a></div>
  </div>
  
  <div class="card align-items-center">
      <div class="card-body" click="logout()"> <a class="leftabita">Logout</a></div>
  </div>
  
  </div>

-->